import { AppState } from '../index';

export const getIconById = (iconId?: number) => (state: AppState) => {
  // console.log('iconId', iconId);
  // console.log('state.icons', state.icons.icons);
  if (iconId && state.icons.icons[iconId]) {
    return state.icons.icons[iconId];
  }
  return null;
};
